import {get, find} from 'lodash';
import { isVideoSection } from '../sections';


export const isValidVideoPage = state => {
  return Boolean(find(get(state, 'article.sections.body', []), isVideoSection));
};
